import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScimApiKey } from '../../../models';
import { AbstractIdentityConfigService } from '../../abstract-identity-config/abstract-identity-config.service';
import { AbstractService } from '../abstract-http/abstract-service';

@Injectable()
export class ScimService extends AbstractService {
  constructor(http: HttpClient, configService: AbstractIdentityConfigService) {
    super(http, configService);
  }

  getScimApiKeys(): Observable<ScimApiKey[]> {
    return this.http.get<ScimApiKey[]>(this.buildUrl(({ scimApiKey }) => scimApiKey));
  }

  generateScimApiKey(api_key_name: string): Observable<ScimApiKey> {
    return this.http.post<ScimApiKey>(
      this.buildUrl(({ scimApiKey }) => scimApiKey),
      { api_key_name } as ScimApiKey
    );
  }

  revokeScimApiKey(api_key_id: string): Observable<ScimApiKey> {
    return this.http.delete<ScimApiKey>(
      this.buildUrl(({ scimApiKey }) => scimApiKey),
      {
        params: {
          api_key_id,
        },
      }
    );
  }
}
